export class CreateTipoFolioRequest {
    public descripcion : string="";    
}